/** Traductions modal détails vente (FR / AR) */
export const salesDetailsModalFr = {
  statusCompleted: 'Terminé',
  statusPending: 'En attente',
  statusCancelled: 'Annulé',
  statusModified: 'Modifié',
  paymentCash: 'Espèces',
  paymentCard: 'Carte',
  paymentTransfer: 'Virement',
  paymentCheck: 'Chèque',
  paymentElectronic: 'Électronique',
  paymentCredit: 'Crédit (créance)',
  notSpecified: 'Non spécifié',
  title: 'Détails de la Vente',
  dateLabel: 'Date',
  statusLabel: 'Statut',
  totalLabel: 'Total',
  paymentMethodLabel: 'Moyen de Paiement',
  customerInfo: 'Informations Client',
  nameLabel: 'Nom',
  phoneLabel: 'Téléphone',
  emailLabel: 'Email',
  addressLabel: 'Adresse',
  productsLabel: 'Produits',
  productCol: 'Produit',
  quantityCol: 'Quantité',
  priceCol: 'Prix',
  lineTotalCol: 'Total',
  grandTotal: 'Total Général',
  notesLabel: 'Notes',
  employeeLabel: 'Employé',
  productUnknown: 'Produit inconnu',
  skuLabel: 'SKU',
  close: 'Fermer',
  voidFull: 'Storno vente',
  voidLine: 'Storno',
  voidLineCol: 'Storno',
  voidLineQtyAria: 'Quantité à annuler',
  voidFullConfirm:
    'Annuler entièrement la vente {{orderId}} ? Le stock, la créance et la caisse seront corrigés.',
  voidLineConfirm: 'Annuler {{qty}}× {{product}} ?',
  voidFullSuccess: 'Vente annulée',
  voidLineSuccess: 'Ligne annulée',
  voidFailed: 'Annulation impossible',
  voidInvalidQty: 'Quantité invalide',
  voidedQtyLabel: 'Annulé : {{qty}}',
  lineVoided: 'Annulé'
};

export const salesDetailsModalAr = {
  statusCompleted: 'مكتمل',
  statusPending: 'في الانتظار',
  statusCancelled: 'ملغي',
  statusModified: 'معدّل',
  paymentCash: 'نقداً',
  paymentCard: 'بطاقة',
  paymentTransfer: 'تحويل',
  paymentCheck: 'شيك',
  paymentElectronic: 'إلكتروني',
  paymentCredit: 'آجل (ذمم)',
  notSpecified: 'غير محدد',
  title: 'تفاصيل البيع',
  dateLabel: 'التاريخ',
  statusLabel: 'الحالة',
  totalLabel: 'المبلغ الإجمالي',
  paymentMethodLabel: 'طريقة الدفع',
  customerInfo: 'معلومات العميل',
  nameLabel: 'الاسم',
  phoneLabel: 'الهاتف',
  emailLabel: 'البريد الإلكتروني',
  addressLabel: 'العنوان',
  productsLabel: 'المنتجات',
  productCol: 'المنتج',
  quantityCol: 'الكمية',
  priceCol: 'السعر',
  lineTotalCol: 'المجموع',
  grandTotal: 'المجموع الإجمالي',
  notesLabel: 'ملاحظات',
  employeeLabel: 'الموظف',
  productUnknown: 'منتج غير معروف',
  skuLabel: 'SKU',
  close: 'إغلاق',
  voidFull: 'إلغاء البيع',
  voidLine: 'إلغاء',
  voidLineCol: 'إلغاء',
  voidLineQtyAria: 'الكمية المراد إلغاؤها',
  voidFullConfirm:
    'إلغاء البيع {{orderId}} بالكامل؟ سيتم تصحيح المخزون والذمم والصندوق.',
  voidLineConfirm: 'إلغاء {{qty}}× {{product}}؟',
  voidFullSuccess: 'تم إلغاء البيع',
  voidLineSuccess: 'تم إلغاء السطر',
  voidFailed: 'تعذر الإلغاء',
  voidInvalidQty: 'كمية غير صالحة',
  voidedQtyLabel: 'ملغى: {{qty}}',
  lineVoided: 'ملغى'
};
